export const warranties = {
  0: {
    en: " Not provided",
    ar: "غير متوفر",
    fr: "Non fourni",
  },
  1: {
    en: "Provided",
    ar: "متوفر",
    fr: "Fournie",
  },
};
